import { Component, ViewChild } from '@angular/core';
import { Nav, Platform, MenuController, Events, ToastController } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { LoginPage } from '../pages/login/login';
import { ListPage } from '../pages/list/list';
import { TrabajadoresPage } from '../pages/trabajadores/trabajadores';
import { EmpresasPage } from '../pages/empresas/empresas';
import { ObrasPage } from '../pages/obras/obras';
import { CalendarioPage } from '../pages/calendario/calendario';
import { TurnosPage } from '../pages/turnos/turnos';
import { AsignarPage } from '../pages/asignar/asignar';
import { UserPage } from '../pages/user/user';
// import { ObjetosPage } from '../pages/objetos/objetos';
// import { GruposPage } from '../pages/grupos/grupos';
import { App } from 'ionic-angular/components/app/app';

import { FuncionesProvider } from '../providers/funciones/funciones';
import { VariablesProvider } from '../providers/variables/variables';
import { ConfigPage } from '../pages/config/config';

// ====== Tipo de item de menú con soporte para submenús ======
interface MenuItem {
  title: string;
  descripcion?: string;
  imagen?: string;
  component?: any;
  children?: MenuItem[];
  open?: boolean;
}

@Component({
  templateUrl: 'app.html',
  providers: [
    StatusBar,
    SplashScreen,
    VariablesProvider,
    FuncionesProvider
  ]
})
export class MyApp {

  @ViewChild(Nav) nav: Nav;

  rootPage: any = LoginPage;

    /** 👇 Añade esto */
  public mostrarChat = false;

  public pages: MenuItem[] = [];
  public pagina: MenuItem[] = [];
  
  public variablesglobales: VariablesProvider;

  constructor(
    private toastCtrl: ToastController,
    public platform: Platform,
    public statusBar: StatusBar,
    public splashScreen: SplashScreen,
    public funciones: FuncionesProvider,
    public variables: VariablesProvider,
    public menu: MenuController,
    public events: Events,
    app: App
  ) {

    
  this.variablesglobales = this.variables;

  if (!this.variables.COLORGLOBAL) {
    this.variables.COLORGLOBAL = '#666666';
  }

  if (!this.variables.COLORGLOBAL2) {
    this.variables.COLORGLOBAL2 = '#666666';
  }

  if (!this.variables.pages) {
    this.variables.pages = [];
  }

  this.platform.ready().then(() => {
    this.platform.registerBackButtonAction(() => {
      app.navPop();
    });
    this.statusBar.styleDefault();
    this.splashScreen.hide();
  });

  /** 👇 Escucha el evento que lanzaremos al hacer login */
  this.events.subscribe('logged-in', () => {
    this.mostrarChat = true;
  });

    // Construir menú cuando cambie la configuración visible
    this.events.subscribe('updateScreen', () => {
      this.pagina = [];
      this.pages = [];

      for (let x = 0; x < this.variables.pages.length; x++) {
        const it = this.variables.pages[x];
        if (it.visible === 'S') {
          switch (it.title) {

            case 'Inicio':
              this.pages.push({ title: 'Inicio', descripcion: '', imagen: '', component: ListPage });
              break;

            case 'Trabajadores':
              this.pages.push({ title: 'Trabajadores', descripcion: '', imagen: '', component: TrabajadoresPage });
              // this.pages.push({ title: 'Grupos', descripcion: '', imagen: '', component: GruposPage });
              break;

            case 'Empresas':
              this.pages.push({ title: 'Empresas', descripcion: '', imagen: '', component: EmpresasPage });
              break;

            case 'Lugares':
              this.pages.push({ title: 'Lugares', descripcion: '', imagen: '', component: ObrasPage });
              break;

            case 'Turnos':
              // Padre "Turnos" con submenú "Asignar Turno"
              this.pages.push({
                title: 'Turnos',
                descripcion: '',
                imagen: '',
                component: TurnosPage, // opcional: navegar al tocar el padre si no usas el icono de toggle
                children: [
                  { title: 'Turnos', descripcion: 'Turnos', imagen: '', component: TurnosPage },
                  { title: 'Asignar a trabajadores', descripcion: 'Asignar a trabajadores', imagen: '', component: AsignarPage }
                ],
                open: false
              });
              break;

            case 'Fiestas':
              this.pages.push({ title: 'Fiestas', descripcion: '', imagen: '', component: CalendarioPage });
              break;

            // case 'Reservas':
            //   this.pages.push({ title: 'Reservas', descripcion: '', imagen: '', component: ObjetosPage });
            //   break;
            case 'Configuracion':
              this.pages.push({ title: 'Configuración', descripcion: '', imagen: '', component: ConfigPage });
              break;

            case 'User':
              this.pages.push({ title: 'User', descripcion: '', imagen: '', component: UserPage });
              break;
          }
        }
      }
    });

    this.menu.enable(true, 'menu1');
  }

  openPage(p: any) {

    if (p.title != 'Turnos') {
      this.menu.close('menu1');
    }
    // Tu botón especial de modo
    if (p === 'config') {
      if (this.variables.MODO === 'real') {
        this.variables.MODO = 'pruebas';
      } else {
        this.variables.MODO = 'real';
      }
      this.nav.setRoot(ListPage);
      return;
    }


  
    // Soporte submenú
    if (p && p.children && p.children.length) {
      p.open = !p.open;   // alterna desplegado
      return;             // NO cerramos menú aquí
    }
  
    // Navegar si es hoja
    if (p && p.component) {
      this.nav.setRoot(p.component);
    }
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts